export function classNames(...args) {
  return args.filter(Boolean).join(' ')
}
